import React, { useEffect, useCallback } from "react";
import { useAsyncError, useNavigate, useRouteError } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

const isDev = window.node_env.isDev;

const maxErrorLength = 10
const maxTraceMessageLength = 200
const errorContainerStyle = {
    display: 'flex',
    padding: `2rem`,
    flexGrow: 1,
    flexDirection: `column`,
}

export function ErrorCatch(props: any) {

    const routeError: any = useRouteError()
    const navigate = useNavigate()
    const asyncError = useAsyncError()

    return (
        <div>
            {/*@ts-ignore*/}
            <div style={errorContainerStyle} >
                {(() => {
                    if ( !isDev ) return `Encountered error`
                    const { status, message, trace } = parseError(routeError, asyncError, { truncate: false });
                    return (
                        <>
                            <h2>Dev Error page</h2>
                            <div>
                                <p>status: {status}</p>
                                <p>message: {message}</p>
                                <p>trace: {trace}</p>
                            </div>
                        </>
                    )
                })()}
            </div>
        </div>
    )
}


function parseError(routeError: any, asyncError: any, options = { truncate: true }) {
    const { truncate = true } = options;
    const { data, error = {}, statusText, status } = routeError;
    const { message, stack } = error
    const errorStatus = status || routeError?.stack?.split(':')[0] || `No status provided.`
    const errorMessage = message || statusText || data || routeError.message || 'No error message provided, please check the console.'
    let errorTrace = stack || routeError?.stack || `No stack trace provided.`
    if ( truncate && errorTrace.length > maxTraceMessageLength ) {
        errorTrace = errorTrace.substring(0, maxTraceMessageLength)
    }
    return {
        status: errorStatus || 'No status given',
        message: errorMessage || 'No error message',
        trace: errorTrace || 'No trace found',
    }
}

